import { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, mediaUrl } from "@/lib/api";
import { useSpace } from "@/context/SpaceContext";
import { useAuth } from "@/context/AuthContext";
import { destinations } from "@/lib/format";
import { useFeed } from "@/hooks/useFeed";
import { LibraryView } from "@/components/library/LibraryView";
import { FromSearchDialog } from "@/components/library/FromSearchDialog";
import { FolderPlus } from "lucide-react";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const vis = params.get("vis") || "";
  const { user } = useAuth();
  const { space, version } = useSpace();
  const fetchPage = useCallback(
    (cursor) => api.get("/search", { params: { space: vis || space, q, cursor, _v: version } }).then((r) => r.data),
    [space, vis, q, version],
  );
  const feed = useFeed(fetchPage);
  const [albums, setAlbums] = useState([]);
  const [selection, setSelection] = useState([]);
  const [making, setMaking] = useState(false);
  const admin = user?.role === "admin";
  useEffect(() => { if (feed.meta?.albums) setAlbums(feed.meta.albums); }, [feed.meta]);
  useEffect(() => setAlbums([]), [q, vis]);
  const visSelect = (
    <select className="tool-select" value={vis} onChange={(e) => setParams(e.target.value ? { q, vis: e.target.value } : { q })} aria-label="Who can see" data-testid="search-visibility-filter">
      <option value="">Everyone I can see</option>
      {destinations(user).map(([k, l]) => <option key={k} value={k}>{k === "private" ? "Private" : l}</option>)}
    </select>
  );
  return (
    <div data-testid="search-page">
      {albums.length > 0 && (
        <section className="search-albums" data-testid="search-albums">
          {albums.map((a) => (
            <Link key={a.id} to={`/albums/${a.id}`} className="search-album" data-testid={`search-album-${a.id}`}>
              {a.cover_url ? <img src={mediaUrl(a.cover_url)} alt="" /> : <span />}
              <span className="truncate">{a.name}</span>
            </Link>
          ))}
        </section>
      )}
      <LibraryView
        feed={feed}
        space={space}
        timeline={!feed.meta || (feed.meta.sort || "").startsWith("taken")}
        empty={`No matches for “${q}”.`}
        onSelection={setSelection}
        toolbar={<><span className="tool-note" data-testid="search-summary">“{q}”{feed.total != null ? ` · ${feed.total}` : ""}</span>{visSelect}
          {admin && feed.items.length > 0 && <button className="tool-btn" onClick={() => setMaking(true)} data-testid="make-album-from-search-button"><FolderPlus size={16} /> <span>Make album from these</span></button>}</>}
      />
      {admin && <FromSearchDialog open={making} onClose={() => setMaking(false)} q={q} space={vis || space} total={feed.total} selected={selection} />}
    </div>
  );
}
